export const channelTranslations = {
  de: {
    discover: "🔎 Entdecken",
    create_tab: "➕ Kanal Erstellen",
    create_header: "Kanal Erstellen",
    edit_header: "Kanal bearbeiten",
    channel_name: "Kanalname (Handle)",
    category: "Kategorie",
    description: "Beschreibung",
    set_image: "Verschlüsseltes Bild festlegen",
    saving: "Wird gespeichert...",
    save_channel: "Kanal speichern",
    cancel: "Abbrechen",
    create_identity_msg: "Erstellen Sie zuerst eine Identität, um Kanäle anzuzeigen, zu abonnieren und zu veröffentlichen.",
    channels_backend_unavailable: "Kanal-Backend-Route nicht verfügbar",
    channels_backend_unavailable_desc: "Das bereitgestellte Backend benötigt die neuen öffentlichen Kanalrouten, bevor Kanäle auf diesem Server verwendet werden können.",
    no_channels: "Keine unentdeckten Kanäle gefunden.",
    searching: "Suche Kanäle...",
    no_description: "Keine Beschreibung.",
    subscribers: "Abonnenten",
    owner: "Eigentümer",
    federated_trust: "Föderiertes Vertrauen",
    search_placeholder: "Nach Kanälen suchen...",
    search_btn: "Suchen",
    subscribe: "Abonnieren",
    unsubscribe: "Deabonnieren",
    block: "Blockieren",
    block_action: "Kanal blockieren",
    report_action: "Kanal melden",
    channel_menu: "Kanalmenü",
    edit_btn: "Bearbeiten",
    comments_on: "Kommentare an",
    comments_off: "Kommentare aus",
    delete_channel: "Kanal löschen",
    decertify: "Entzertifizieren",
    certify: "Kanal Zertifizieren",
    public_channel: "Öffentlicher Kanal",
    admin_console: "Admin-Konsole",
    viewer_mode: "Zuschauer-Modus",
    verified_by: "✓ Verifiziert durch",
    create_channel_empty_desc: "Erstelle einen neuen Kanal, um Ankündigungen kryptografisch signiert zu veröffentlichen.",
    create_channel_empty_btn: "Jetzt Erstellen",
    report_title: "Kanal melden",
    report_category: "Kategorie des Verstoßes",
    report_severity: "Dringlichkeit / Dringlichkeitsstufe",
    report_notes: "Zusätzliche Anmerkungen oder Nachweise",
    report_placeholder: "Geben Sie details oder den kryptografischen Nachweis des Verstoßes an...",
    report_submit: "Meldung abschicken",
    report_submitting: "Wird gemeldet...",
    search_posts: "Beitrag im Kanal suchen...",
    delete_comment: "Löschen",
    no_comments: "Keine Kommentare vorhanden. Sei der Erste!",
    comments_disabled: "Kommentare sind fuer diesen Kanal deaktiviert.",
    comment_placeholder: "Kommentar schreiben...",
    send: "Senden",
    plan_post: "Planen",
    reset: "Reset",
    publish: "Veröffentlichen",
    publishing: "Veröffentliche...",
    plan_label: "📅 Planen:",
    attached_image: "Bild angehängt (verschlüsselt)"
  },
  en: {
    discover: "🔎 Discover",
    create_tab: "➕ Create Channel",
    create_header: "Create Channel",
    edit_header: "Edit Channel",
    channel_name: "Channel name (Handle)",
    category: "Category",
    description: "Description",
    set_image: "Set encrypted image",
    saving: "Saving...",
    save_channel: "Save Channel",
    cancel: "Cancel",
    create_identity_msg: "Create an identity first to view, subscribe, and publish channels.",
    channels_backend_unavailable: "Channels backend route unavailable",
    channels_backend_unavailable_desc: "The deployed backend needs the new public channel routes before channels can be used on this server.",
    no_channels: "No undiscovered channels found.",
    searching: "Searching channels...",
    no_description: "No description.",
    subscribers: "subscribers",
    owner: "Owner",
    federated_trust: "Federated Trust",
    search_placeholder: "Search channels...",
    search_btn: "Search",
    subscribe: "Subscribe",
    unsubscribe: "Unsubscribe",
    block: "Block",
    block_action: "Block channel",
    report_action: "Report channel",
    channel_menu: "Channel Menu",
    edit_btn: "Edit",
    comments_on: "Comments On",
    comments_off: "Comments Off",
    delete_channel: "Delete Channel",
    decertify: "Decertify",
    certify: "Certify Channel",
    public_channel: "Public Channel",
    admin_console: "Admin Console",
    viewer_mode: "Viewer Mode",
    verified_by: "✓ Verified by",
    create_channel_empty_desc: "Create a new channel to publish cryptographically signed announcements.",
    create_channel_empty_btn: "Create Now",
    report_title: "Report channel",
    report_category: "Violation category",
    report_severity: "Urgency / Severity level",
    report_notes: "Additional notes or evidence",
    report_placeholder: "Provide details or cryptographic proof of violation...",
    report_submit: "Send report",
    report_submitting: "Reporting...",
    search_posts: "Search posts in channel...",
    delete_comment: "Delete",
    no_comments: "No comments yet. Be the first!",
    comments_disabled: "Comments are disabled for this channel.",
    comment_placeholder: "Write a comment...",
    send: "Send",
    plan_post: "Schedule",
    reset: "Reset",
    publish: "Publish",
    publishing: "Publishing...",
    plan_label: "📅 Schedule:",
    attached_image: "Image attached (encrypted)"
  },
  ru: {
    discover: "🔎 Найти",
    create_tab: "➕ Создать канал",
    create_header: "Создать канал",
    edit_header: "Редактировать канал",
    channel_name: "Имя канала (Handle)",
    category: "Категория",
    description: "Описание",
    set_image: "Установить шифрованное изображение",
    saving: "Сохранение...",
    save_channel: "Сохранить канал",
    cancel: "Отмена",
    create_identity_msg: "Создайте сначала идентичность, чтобы просматривать, подписываться и публиковать каналы.",
    channels_backend_unavailable: "Маршрут бэкенда каналов недоступен",
    channels_backend_unavailable_desc: "Развернутому бэкенду требуются новые маршруты публичных каналов, прежде чем каналы можно будет использовать на этом сервере.",
    no_channels: "Неоткрытые каналы не найдены.",
    searching: "Поиск каналов...",
    no_description: "Нет описания.",
    subscribers: "подписчиков",
    owner: "Владелец",
    federated_trust: "Федеративное доверие",
    search_placeholder: "Поиск каналов...",
    search_btn: "Найти",
    subscribe: "Подписаться",
    unsubscribe: "Отписаться",
    block: "Заблокировать",
    block_action: "Заблокировать канал",
    report_action: "Пожаловаться",
    channel_menu: "Меню канала",
    edit_btn: "Редактировать",
    comments_on: "Комментарии вкл.",
    comments_off: "Комментарии выкл.",
    delete_channel: "Удалить канал",
    decertify: "Десертифицировать",
    certify: "Сертифицировать канал",
    public_channel: "Публичный канал",
    admin_console: "Консоль админа",
    viewer_mode: "Режим зрителя",
    verified_by: "✓ Проверено",
    create_channel_empty_desc: "Создайте новый канал для публикации криптографически подписанных объявлений.",
    create_channel_empty_btn: "Создать сейчас",
    report_title: "Пожаловаться на канал",
    report_category: "Категория нарушения",
    report_severity: "Уровень срочности / тяжести",
    report_notes: "Дополнительные примечания или доказательства",
    report_placeholder: "Предоставьте подробности или криптографическое подтверждение нарушения...",
    report_submit: "Отправить жалобу",
    report_submitting: "Отправка...",
    search_posts: "Поиск публикаций в канале...",
    delete_comment: "Удалить",
    no_comments: "Комментариев пока нет. Будьте первыми!",
    comments_disabled: "Комментарии для этого канала отключены.",
    comment_placeholder: "Напишите комментарий...",
    send: "Отправить",
    plan_post: "Запланировать",
    reset: "Сбросить",
    publish: "Опубликовать",
    publishing: "Публикация...",
    plan_label: "📅 Запланировать:",
    attached_image: "Изображение прикреплено (зашифровано)"
  },
  es: {
    discover: "🔎 Descubrir",
    create_tab: "➕ Crear canal",
    create_header: "Crear canal",
    edit_header: "Editar canal",
    channel_name: "Nombre del canal (Handle)",
    category: "Categoría",
    description: "Descripción",
    set_image: "Establecer imagen cifrada",
    saving: "Guardando...",
    save_channel: "Guardar canal",
    cancel: "Cancelar",
    create_identity_msg: "Cree una identidad primero para ver, suscribirse y publicar canales.",
    channels_backend_unavailable: "Ruta del backend de canales no disponible",
    channels_backend_unavailable_desc: "El backend implementado necesita las nuevas rutas de canales públicos antes de poder utilizarlas en este servidor.",
    no_channels: "No se encontraron canales no descubiertos.",
    searching: "Buscando canales...",
    no_description: "Sin descripción.",
    subscribers: "suscriptores",
    owner: "Propietario",
    federated_trust: "Confianza federada",
    search_placeholder: "Buscar canales...",
    search_btn: "Buscar",
    subscribe: "Suscribirse",
    unsubscribe: "Deabonnieren",
    block: "Bloquear",
    block_action: "Bloquear canal",
    report_action: "Reportar canal",
    channel_menu: "Menú del canal",
    edit_btn: "Editar",
    comments_on: "Comentarios activados",
    comments_off: "Comentarios desactivados",
    delete_channel: "Eliminar canal",
    decertify: "Descertificar",
    certify: "Certificar canal",
    public_channel: "Canal público",
    admin_console: "Consola de administración",
    viewer_mode: "Modo espectador",
    verified_by: "✓ Verificado por",
    create_channel_empty_desc: "Cree un nuevo canal para publicar anuncios firmados criptográficamente.",
    create_channel_empty_btn: "Crear ahora",
    report_title: "Reportar canal",
    report_category: "Categoría de infracción",
    report_severity: "Nivel de urgencia / gravedad",
    report_notes: "Notas adicionales o evidencia",
    report_placeholder: "Proporcione detalles o prueba criptográfica de la infracción...",
    report_submit: "Enviar reporte",
    report_submitting: "Reportando...",
    search_posts: "Buscar publicaciones en el canal...",
    delete_comment: "Eliminar",
    no_comments: "Aún no hay comentarios. ¡Sé el primero!",
    comments_disabled: "Los comentarios están desactivados para este canal.",
    comment_placeholder: "Escribe un comentario...",
    send: "Enviar",
    plan_post: "Programar",
    reset: "Restablecer",
    publish: "Publicar",
    publishing: "Publicando...",
    plan_label: "📅 Programar:",
    attached_image: "Imagen adjunta (cifrada)"
  },
  fr: {
    discover: "🔎 Découvrir",
    create_tab: "➕ Créer un canal",
    create_header: "Créer un canal",
    edit_header: "Modifier le canal",
    channel_name: "Nom du canal (Handle)",
    category: "Catégorie",
    description: "Description",
    set_image: "Définir l'image chiffrée",
    saving: "Enregistrement...",
    save_channel: "Enregistrer le canal",
    cancel: "Annuler",
    create_identity_msg: "Créez d'abord une identité pour voir, s'abonner et publier des canaux.",
    channels_backend_unavailable: "Route du backend de canaux indisponible",
    channels_backend_unavailable_desc: "Le backend déployé a besoin des nouvelles routes de canaux publics avant que les canaux puissent être utilisés sur ce serveur.",
    no_channels: "Aucun canal non découvert trouvé.",
    searching: "Recherche de canaux...",
    no_description: "Aucune description.",
    subscribers: "abonnés",
    owner: "Propriétaire",
    federated_trust: "Confiance fédérée",
    search_placeholder: "Rechercher des canaux...",
    search_btn: "Rechercher",
    subscribe: "S'abonner",
    unsubscribe: "Se désabonner",
    block: "Bloquer",
    block_action: "Bloquer le canal",
    report_action: "Signaler le canal",
    channel_menu: "Menu du canal",
    edit_btn: "Modifier",
    comments_on: "Commentaires activés",
    comments_off: "Commentaires désactivés",
    delete_channel: "Supprimer le canal",
    decertify: "Décertifier",
    certify: "Certifier le canal",
    public_channel: "Canal public",
    admin_console: "Console d'administration",
    viewer_mode: "Mode observateur",
    verified_by: "✓ Vérifié par",
    create_channel_empty_desc: "Créez un nouveau canal pour publier des annonces signées cryptographiquement.",
    create_channel_empty_btn: "Créer maintenant",
    report_title: "Signaler le canal",
    report_category: "Catégorie de violation",
    report_severity: "Niveau d'urgence / gravité",
    report_notes: "Notes supplémentaires ou preuves",
    report_placeholder: "Fournissez des détails ou une preuve cryptographique de la violation...",
    report_submit: "Envoyer le signalement",
    report_submitting: "Signalement en cours...",
    search_posts: "Rechercher des publications...",
    delete_comment: "Supprimer",
    no_comments: "Aucun commentaire pour le moment. Soyez le premier !",
    comments_disabled: "Les commentaires sont désactivés pour ce canal.",
    comment_placeholder: "Écrire un commentaire...",
    send: "Envoyer",
    plan_post: "Planifier",
    reset: "Réinitialiser",
    publish: "Publier",
    publishing: "Publication...",
    plan_label: "📅 Planifier:",
    attached_image: "Image jointe (chiffrée)"
  },
  fa: {
    discover: "🔎 کشف کردن",
    create_tab: "➕ ایجاد کانال",
    create_header: "ایجاد کانال",
    edit_header: "ویرایش کانال",
    channel_name: "نام کانال (Handle)",
    category: "دسته‌بندی",
    description: "توضیح",
    set_image: "تنظیم تصویر رمزگذاری شده",
    saving: "در حال ذخیره‌سازی...",
    save_channel: "ذخیره کانال",
    cancel: "لغو",
    create_identity_msg: "ابتدا یک هویت ایجاد کنید تا بتوانید کانال‌ها را مشاهده کنید، عضو شوید و منتشر کنید.",
    channels_backend_unavailable: "مسیر بک‌اند کانال‌ها در دسترس نیست",
    channels_backend_unavailable_desc: "بک‌اند مستقر شده به مسیرهای جدید کانال عمومی نیاز دارد قبل از اینکه کانال‌ها در این سرور قابل استفاده باشند.",
    no_channels: "هیچ کانال کشف‌نشده‌ای یافت نشد.",
    searching: "در حال جستجوی کانال‌ها...",
    no_description: "بدون توضیح.",
    subscribers: "دنبال‌کننده",
    owner: "مالک",
    federated_trust: "اعتماد فدرال",
    search_placeholder: "جستجوی کانال‌ها...",
    search_btn: "جستجو",
    subscribe: "عضو شدن",
    unsubscribe: "لغو عضویت",
    block: "مسدود کردن",
    block_action: "مسدود کردن کانال",
    report_action: "گزارش کانال",
    channel_menu: "منوی کانال",
    edit_btn: "ویرایش",
    comments_on: "نظرات فعال",
    comments_off: "نظرات غیرفعال",
    delete_channel: "حذف کانال",
    decertify: "لغو تاییدیه",
    certify: "تایید کانال",
    public_channel: "کانال عمومی",
    admin_console: "کنسول مدیریت",
    viewer_mode: "حالت نمایش",
    verified_by: "✓ تایید شده توسط",
    create_channel_empty_desc: "یک کانال جدید برای انتشار اطلاعیه‌های امضا شده به صورت رمزنگاری ایجاد کنید.",
    create_channel_empty_btn: "اکنون ایجاد کنید",
    report_title: "گزارش کانال",
    report_category: "دسته‌بندی تخلف",
    report_severity: "سطح اضطرار / شدت",
    report_notes: "یادداشت‌ها یا شواهد اضافی",
    report_placeholder: "جزئیات یا اثبات رمزنگاری تخلف را ارائه دهید...",
    report_submit: "ارسال گزارش",
    report_submitting: "در حال گزارش...",
    search_posts: "جستجوی پست‌ها در کانال...",
    delete_comment: "حذف",
    no_comments: "هنوز نظری وجود ندارد. اولین نفر باشید!",
    comments_disabled: "نظرات برای این کانال غیرفعال شده است.",
    comment_placeholder: "نوشتن نظر...",
    send: "ارسال",
    plan_post: "زمان‌بندی",
    reset: "بازنشانی",
    publish: "انتشار",
    publishing: "در حال انتشار...",
    plan_label: "📅 زمان‌بندی:",
    attached_image: "تصویر پیوست شده (رمزگذاری شده)"
  },
  ja: {
    discover: "🔎 見つける",
    create_tab: "➕ チャンネル作成",
    create_header: "チャンネル作成",
    edit_header: "チャンネル編集",
    channel_name: "チャンネル名 (Handle)",
    category: "カテゴリ",
    description: "説明",
    set_image: "暗号化画像を設定",
    saving: "保存中...",
    save_channel: "チャンネルを保存",
    cancel: "キャンセル",
    create_identity_msg: "チャンネルを表示、購読、公開するには、まずアイデンティティを作成してください。",
    channels_backend_unavailable: "チャンネルのバックエンドルートを利用できません",
    channels_backend_unavailable_desc: "このサーバーでチャンネルを使用する前に、デプロイされたバックエンドに新しいパブリックチャンネルルートを追加する必要があります。",
    no_channels: "未発見のチャンネルが見つかりませんでした。",
    searching: "チャンネルを検索中...",
    no_description: "説明はありません。",
    subscribers: "購読者",
    owner: "オーナー",
    federated_trust: "フェデレーション信頼",
    search_placeholder: "チャンネルを検索...",
    search_btn: "検索",
    subscribe: "購読する",
    unsubscribe: "購読解除",
    block: "ブロック",
    block_action: "チャンネルをブロック",
    report_action: "チャンネルを報告",
    channel_menu: "チャンネルメニュー",
    edit_btn: "編集",
    comments_on: "コメントオン",
    comments_off: "コメントオフ",
    delete_channel: "チャンネルを削除",
    decertify: "認定取り消し",
    certify: "チャンネルを認定",
    public_channel: "パブリックチャンネル",
    admin_console: "管理者コンソール",
    viewer_mode: "ビューアーモード",
    verified_by: "✓ 認定元",
    create_channel_empty_desc: "暗号署名されたお知らせを公開するための新しいチャンネルを作成します。",
    create_channel_empty_btn: "今すぐ作成",
    report_title: "チャンネルを報告",
    report_category: "違反のカテゴリ",
    report_severity: "緊急度 / 深刻度",
    report_notes: "追加のメモまたは証拠",
    report_placeholder: "違反の詳細または暗号証明を提供してください...",
    report_submit: "報告を送信",
    report_submitting: "報告中...",
    search_posts: "チャンネル内の投稿を検索...",
    delete_comment: "削除",
    no_comments: "コメントはまだありません。最初のコメントを投稿しましょう！",
    comments_disabled: "このチャンネルのコメントは無効になっています。",
    comment_placeholder: "コメントを書く...",
    send: "送信",
    plan_post: "スケジュール指定",
    reset: "リセット",
    publish: "公開",
    publishing: "公開中...",
    plan_label: "📅 スケジュール:",
    attached_image: "画像が添付されました (暗号化)"
  },
  pt: {
    discover: "🔎 Descobrir",
    create_tab: "➕ Criar Canal",
    create_header: "Criar Canal",
    edit_header: "Editar Canal",
    channel_name: "Nome do canal (Handle)",
    category: "Categoria",
    description: "Descrição",
    set_image: "Definir imagem criptografada",
    saving: "Salvando...",
    save_channel: "Salvar Canal",
    cancel: "Cancelar",
    create_identity_msg: "Crie uma identidade primeiro para ver, se inscrever e publicar canais.",
    channels_backend_unavailable: "Rota do backend dos canais indisponível",
    channels_backend_unavailable_desc: "O backend implantado precisa das novas rotas de canais públicos antes de poder utilizá-las neste servidor.",
    no_channels: "Nenhum canal não descoberto encontrado.",
    searching: "Buscando canais...",
    no_description: "Sem descrição.",
    subscribers: "seguidores",
    owner: "Proprietário",
    federated_trust: "Confiança Federada",
    search_placeholder: "Buscar canais...",
    search_btn: "Buscar",
    subscribe: "Inscrever-se",
    unsubscribe: "Cancelar inscrição",
    block: "Bloquear",
    block_action: "Bloquear canal",
    report_action: "Denunciar canal",
    channel_menu: "Menu do Canal",
    edit_btn: "Editar",
    comments_on: "Comentários ativados",
    comments_off: "Comentários desativados",
    delete_channel: "Excluir Canal",
    decertify: "Descertificar",
    certify: "Certificar Canal",
    public_channel: "Canal Público",
    admin_console: "Console de Admin",
    viewer_mode: "Modo Visualizador",
    verified_by: "✓ Verificado por",
    create_channel_empty_desc: "Crie um novo canal para publicar anúncios assinados criptograficamente.",
    create_channel_empty_btn: "Criar Agora",
    report_title: "Denunciar canal",
    report_category: "Categoria de violação",
    report_severity: "Nível de urgência / gravidade",
    report_notes: "Notas adicionais ou evidências",
    report_placeholder: "Forneça detalhes ou prova criptográfica da violação...",
    report_submit: "Enviar denúncia",
    report_submitting: "Enviando...",
    search_posts: "Buscar postagens no canal...",
    delete_comment: "Excluir",
    no_comments: "Nenhum comentário ainda. Seja o primeiro!",
    comments_disabled: "Os comentários estão desativados para este canal.",
    comment_placeholder: "Escreva um comentário...",
    send: "Enviar",
    plan_post: "Agendar",
    reset: "Redefinir",
    publish: "Publicar",
    publishing: "Publicando...",
    plan_label: "📅 Agendar:",
    attached_image: "Imagem anexada (criptografada)"
  },
  ar: {
    discover: "🔎 اكتشاف",
    create_tab: "➕ إنشاء قناة",
    create_header: "إنشاء قناة",
    edit_header: "تعديل القناة",
    channel_name: "اسم القناة (Handle)",
    category: "الفئة",
    description: "الوصف",
    set_image: "تعيين صورة مشفرة",
    saving: "جاري الحفظ...",
    save_channel: "حفظ القناة",
    cancel: "إلغاء",
    create_identity_msg: "أنشئ هوية أولاً لتتمكن من عرض القنوات والاشتراك فيها ونشرها.",
    channels_backend_unavailable: "مسار القنوات على الخادم غير متوفر",
    channels_backend_unavailable_desc: "يحتاج الخادم المنشور إلى مسارات القنوات العامة الجديدة قبل أن يتم استخدامها على هذا الخادم.",
    no_channels: "لم يتم العثور على قنوات غير مكتشفة.",
    searching: "جاري البحث عن قنوات...",
    no_description: "لا يوجد وصف.",
    subscribers: "مشتركين",
    owner: "المالك",
    federated_trust: "الثقة الموزعة",
    search_placeholder: "البحث عن قنوات...",
    search_btn: "بحث",
    subscribe: "اشتراك",
    unsubscribe: "إلغاء الاشتراك",
    block: "حظر",
    block_action: "حظر القناة",
    report_action: "الإبلاغ عن القناة",
    channel_menu: "قائمة القناة",
    edit_btn: "تعديل",
    comments_on: "التعليقات مفعلة",
    comments_off: "التعليقات معطلة",
    delete_channel: "حذف القناة",
    decertify: "إلغاء التوثيق",
    certify: "توثيق القناة",
    public_channel: "قناة عامة",
    admin_console: "لوحة التحكم",
    viewer_mode: "وضع القراءة",
    verified_by: "✓ موثق من",
    create_channel_empty_desc: "أنشئ قناة جديدة لنشر إعلانات موقعة تشفيرياً.",
    create_channel_empty_btn: "إنشاء الآن",
    report_title: "إبلاغ عن قناة",
    report_category: "فئة المخالفة",
    report_severity: "مستوى الخطورة",
    report_notes: "ملاحظات إضافية أو أدلة",
    report_placeholder: "قدم تفاصيل أو إثباتاً تشفيرياً للمخالفة...",
    report_submit: "إرسال الإبلاغ",
    report_submitting: "جاري الإرسال...",
    search_posts: "البحث عن منشورات بالقناة...",
    delete_comment: "حذف",
    no_comments: "لا توجد تعليقات بعد. كن أول من يعلق!",
    comments_disabled: "التعليقات معطلة لهذه القناة.",
    comment_placeholder: "اكتب تعليقاً...",
    send: "إرسال",
    plan_post: "جدولة",
    reset: "إعادة ضبط",
    publish: "نشر",
    publishing: "جاري النشر...",
    plan_label: "📅 جدولة:",
    attached_image: "الصورة مرفقة (مشفرة)"
  },
  zh: {
    discover: "🔎 发现",
    create_tab: "➕ 创建频道",
    create_header: "创建频道",
    edit_header: "编辑频道",
    channel_name: "频道名称 (Handle)",
    category: "类别",
    description: "描述",
    set_image: "设置加密图片",
    saving: "保存中...",
    save_channel: "保存频道",
    cancel: "取消",
    create_identity_msg: "请先创建一个身份以查看、订阅及发布频道。",
    channels_backend_unavailable: "频道后端路由不可用",
    channels_backend_unavailable_desc: "部署的后端需要配置新的公共频道路由，才能在此服务器上使用频道。",
    no_channels: "未找到未订阅频道。",
    searching: "正在搜索频道...",
    no_description: "暂无描述。",
    subscribers: "位订阅者",
    owner: "所有者",
    federated_trust: "联邦信任",
    search_placeholder: "搜索频道...",
    search_btn: "搜索",
    subscribe: "订阅",
    unsubscribe: "取消订阅",
    block: "屏蔽",
    block_action: "屏蔽频道",
    report_action: "举报频道",
    channel_menu: "频道菜单",
    edit_btn: "编辑",
    comments_on: "评论开启",
    comments_off: "评论关闭",
    delete_channel: "删除频道",
    decertify: "取消认证",
    certify: "认证频道",
    public_channel: "公共频道",
    admin_console: "管理控制台",
    viewer_mode: "观众模式",
    verified_by: "✓ 认证方",
    create_channel_empty_desc: "创建一个新频道以发布经过加密签名的公告。",
    create_channel_empty_btn: "立即创建",
    report_title: "举报频道",
    report_category: "违规类别",
    report_severity: "紧急/严重程度",
    report_notes: "附加说明或证据",
    report_placeholder: "提供违规详情或加密证明...",
    report_submit: "提交举报",
    report_submitting: "正在举报...",
    search_posts: "搜索频道内的帖子...",
    delete_comment: "删除",
    no_comments: "暂无评论。成为第一个评论的人！",
    comments_disabled: "该频道的评论功能已禁用。",
    comment_placeholder: "撰写评论...",
    send: "发送",
    plan_post: "定时发送",
    reset: "重置",
    publish: "发布",
    publishing: "正在发布...",
    plan_label: "📅 定时:",
    attached_image: "图片已附加（加密）"
  },
  hi: {
    discover: "🔎 खोजें",
    create_tab: "➕ चैनल बनाएं",
    create_header: "चैनल बनाएं",
    edit_header: "चैनल संपादित करें",
    channel_name: "चैनल का नाम (Handle)",
    category: "श्रेणी",
    description: "विवरण",
    set_image: "क्रिप्टेड इमेज सेट करें",
    saving: "सहेज रहा है...",
    save_channel: "चैनल सहेजें",
    cancel: "रद्द करें",
    create_identity_msg: "चैनल देखने, सदस्यता लेने और प्रकाशित करने के लिए पहले एक पहचान बनाएं।",
    channels_backend_unavailable: "चैनल बैकएंड उपलब्ध नहीं है",
    channels_backend_unavailable_desc: "इस सर्वर पर चैनल का उपयोग करने से पहले तैनात बैकएंड को नए सार्वजनिक चैनल रूट की आवश्यकता है।",
    no_channels: "कोई नया चैनल नहीं मिला।",
    searching: "चैनल खोजे जा रहे हैं...",
    no_description: "कोई विवरण नहीं।",
    subscribers: "सदस्य",
    owner: "स्वामी",
    federated_trust: "संघीय ट्रस्ट",
    search_placeholder: "चैनल खोजें...",
    search_btn: "खोजें",
    subscribe: "सदस्यता लें",
    unsubscribe: "सदस्यता रद्द करें",
    block: "ब्लॉक करें",
    block_action: "चैनल ब्लॉक करें",
    report_action: "चैनल की रिपोर्ट करें",
    channel_menu: "चैनल मेनू",
    edit_btn: "संपादित करें",
    comments_on: "टिप्पणियाँ चालू",
    comments_off: "टिप्पणियाँ बंद",
    delete_channel: "चैनल हटाएं",
    decertify: "प्रमाणन वापस लें",
    certify: "चैनल प्रमाणित करें",
    public_channel: "सार्वजनिक चैनल",
    admin_console: "एडमिन कंसोल",
    viewer_mode: "व्यूअर मोड",
    verified_by: "✓ द्वारा सत्यापित",
    create_channel_empty_desc: "क्रिप्टोग्राफ़िक रूप से हस्ताक्षरित घोषणाएँ प्रकाशित करने के लिए एक नया चैनल बनाएँ।",
    create_channel_empty_btn: "अभी बनाएं",
    report_title: "चैनल की रिपोर्ट करें",
    report_category: "उल्लंघन की श्रेणी",
    report_severity: "गंभीरता का स्तर",
    report_notes: "अतिरिक्त नोट या साक्ष्य",
    report_placeholder: "उल्लंघन का विवरण या क्रिप्टोग्राफ़िक प्रमाण प्रदान करें...",
    report_submit: "रिपोर्ट भेजें",
    report_submitting: "रिपोर्ट भेजी जा रही है...",
    search_posts: "चैनल में पोस्ट खोजें...",
    delete_comment: "हटाएं",
    no_comments: "अभी तक कोई टिप्पणी नहीं है। पहले बनें!",
    comments_disabled: "इस चैनल के लिए टिप्पणियाँ अक्षम हैं।",
    comment_placeholder: "एक टिप्पणी लिखें...",
    send: "भेजें",
    plan_post: "शेड्यूल करें",
    reset: "रीसेट",
    publish: "प्रकाशित करें",
    publishing: "प्रकाशित किया जा रहा है...",
    plan_label: "📅 शेड्यूल:",
    attached_image: "चित्र संलग्न (एन्क्रिप्टेड)"
  },
  tr: {
    discover: "🔎 Keşfet",
    create_tab: "➕ Kanal Oluştur",
    create_header: "Kanal Oluştur",
    edit_header: "Kanalı Düzenle",
    channel_name: "Kanal adı (Handle)",
    category: "Kategori",
    description: "Açıklama",
    set_image: "Şifreli görsel belirle",
    saving: "Kaydediliyor...",
    save_channel: "Kanalı Kaydet",
    cancel: "İptal",
    create_identity_msg: "Kanalları görüntülemek, abone olmak ve yayınlamak için önce bir kimlik oluşturun.",
    channels_backend_unavailable: "Kanal backend rotası kullanılamıyor",
    channels_backend_unavailable_desc: "Bu sunucuda kanalların kullanılabilmesi için önce dağıtılan backend'in yeni ortak kanal rotalarını desteklemesi gerekir.",
    no_channels: "Keşfedilmemiş kanal bulunamadı.",
    searching: "Kanallar aranıyor...",
    no_description: "Açıklama yok.",
    subscribers: "abone",
    owner: "Sahibi",
    federated_trust: "Federe Güven",
    search_placeholder: "Kanal ara...",
    search_btn: "Ara",
    subscribe: "Abone Ol",
    unsubscribe: "Abonelikten Çık",
    block: "Engelle",
    block_action: "Kanalı engelle",
    report_action: "Kanalı bildir",
    channel_menu: "Kanal Menüsü",
    edit_btn: "Düzenle",
    comments_on: "Yorumlar Açık",
    comments_off: "Yorumlar Kapalı",
    delete_channel: "Kanalı Sil",
    decertify: "Sertifikayı İptal Et",
    certify: "Kanalı Sertifikalandır",
    public_channel: "Genel Kanal",
    admin_console: "Yönetici Konsolu",
    viewer_mode: "İzleyici Modu",
    verified_by: "✓ Doğrulayan",
    create_channel_empty_desc: "Kriptografik olarak imzalanmış duyurular yayınlamak için yeni bir kanal oluşturun.",
    create_channel_empty_btn: "Şimdi Oluştur",
    report_title: "Kanalı bildir",
    report_category: "İhlal kategorisi",
    report_severity: "Aciliyet / Önem derecesi",
    report_notes: "Ek notlar veya kanıtlar",
    report_placeholder: "İhlalin ayrıntılarını veya kriptografik kanıtını sağlayın...",
    report_submit: "Bildirimi gönder",
    report_submitting: "Bildiriliyor...",
    search_posts: "Kanalda gönderi ara...",
    delete_comment: "Sil",
    no_comments: "Henüz yorum yok. İlk siz olun!",
    comments_disabled: "Bu kanal için yorumlar devre dışı bırakıldı.",
    comment_placeholder: "Yorum yaz...",
    send: "Gönder",
    plan_post: "Planla",
    reset: "Sıfırla",
    publish: "Yayınla",
    publishing: "Yayınlanıyor...",
    plan_label: "📅 Planla:",
    attached_image: "Görsel eklendi (şifreli)"
  },
  it: {
    discover: "🔎 Scopri",
    create_tab: "➕ Crea Canale",
    create_header: "Crea Canale",
    edit_header: "Modifica Canale",
    channel_name: "Nome del canale (Handle)",
    category: "Categoria",
    description: "Descrizione",
    set_image: "Imposta immagine crittografata",
    saving: "Salvataggio...",
    save_channel: "Salva Canale",
    cancel: "Annulla",
    create_identity_msg: "Crea prima un'identità per visualizzare, iscriverti e pubblicare canali.",
    channels_backend_unavailable: "Rotta backend dei canali non disponibile",
    channels_backend_unavailable_desc: "Il backend distribuito richiede le nuove rotte per i canali pubblici prima che sia possibile utilizzarli su questo server.",
    no_channels: "Nessun canale non scoperto trovato.",
    searching: "Ricerca canali in corso...",
    no_description: "Nessuna descrizione.",
    subscribers: "iscritti",
    owner: "Proprietario",
    federated_trust: "Fiducia Federata",
    search_placeholder: "Cerca canali...",
    search_btn: "Cerca",
    subscribe: "Iscriviti",
    unsubscribe: "Disiscriviti",
    block: "Blocca",
    block_action: "Blocca canale",
    report_action: "Segnala canale",
    channel_menu: "Menu Canale",
    edit_btn: "Modifica",
    comments_on: "Commenti attivi",
    comments_off: "Commenti disattivi",
    delete_channel: "Elimina Canale",
    decertify: "Rimuovi certificazione",
    certify: "Certifica Canale",
    public_channel: "Canale Pubblico",
    admin_console: "Console Amministratore",
    viewer_mode: "Modalità Visore",
    verified_by: "✓ Verificato da",
    create_channel_empty_desc: "Crea un nuovo canale per pubblicare annunci firmati crittograficamente.",
    create_channel_empty_btn: "Crea Ora",
    report_title: "Segnala canale",
    report_category: "Categoria di violazione",
    report_severity: "Livello di urgenza / gravità",
    report_notes: "Note aggiuntive o prove",
    report_placeholder: "Fornisci dettagli o prove crittografiche della violazione...",
    report_submit: "Invia segnalazione",
    report_submitting: "Invio segnalazione...",
    search_posts: "Cerca post nel canale...",
    delete_comment: "Elimina",
    no_comments: "Nessun commento ancora. Scrivi il primo!",
    comments_disabled: "I commenti sono disabilitati per questo canale.",
    comment_placeholder: "Scrivi un commento...",
    send: "Invia",
    plan_post: "Programma",
    reset: "Reimposta",
    publish: "Pubblica",
    publishing: "Pubblicazione...",
    plan_label: "📅 Programma:",
    attached_image: "Immagine allegata (crittografata)"
  },
  pl: {
    discover: "🔎 Odkrywaj",
    create_tab: "➕ Utwórz kanał",
    create_header: "Utwórz kanał",
    edit_header: "Edytuj kanał",
    channel_name: "Nazwa kanału (Handle)",
    category: "Kategoria",
    description: "Opis",
    set_image: "Ustaw zaszyfrowany obraz",
    saving: "Zapisywanie...",
    save_channel: "Zapisz kanał",
    cancel: "Anuluj",
    create_identity_msg: "Utwórz najpierw tożsamość, aby wyświetlać, subskrybować i tworzyć kanały.",
    channels_backend_unavailable: "Trasa backendu kanałów jest niedostępna",
    channels_backend_unavailable_desc: "Wdrożony backend wymaga nowych tras kanałów publicznych, zanim będzie można z nich korzystać na tym serwerze.",
    no_channels: "Nie znaleziono nieodkrytych kanałów.",
    searching: "Wyszukiwanie kanałów...",
    no_description: "Brak opisu.",
    subscribers: "subskrybentów",
    owner: "Właściciel",
    federated_trust: "Zaufanie federacyjne",
    search_placeholder: "Wyszukaj kanały...",
    search_btn: "Szukaj",
    subscribe: "Subskrybuj",
    unsubscribe: "Anuluj subskrypcję",
    block: "Zablokuj",
    block_action: "Zablokuj kanał",
    report_action: "Zgłoś kanał",
    channel_menu: "Menu kanału",
    edit_btn: "Edytuj",
    comments_on: "Komentarze włączone",
    comments_off: "Komentarze wyłączone",
    delete_channel: "Usuń kanał",
    decertify: "Cofnij certyfikację",
    certify: "Certyfikuj kanał",
    public_channel: "Kanał publiczny",
    admin_console: "Konsola administratora",
    viewer_mode: "Tryb widza",
    verified_by: "✓ Zweryfikowane przez",
    create_channel_empty_desc: "Utwórz nowy kanał, aby publikować ogłoszenia podpisane kryptograficznie.",
    create_channel_empty_btn: "Utwórz teraz",
    report_title: "Zgłoś kanał",
    report_category: "Kategoria naruszenia",
    report_severity: "Poziom pilności / dotkliwości",
    report_notes: "Dodatkowe uwagi lub dowody",
    report_placeholder: "Podaj szczegóły lub dowód kryptograficzny naruszenia...",
    report_submit: "Wyślij zgłoszenie",
    report_submitting: "Zgłaszanie...",
    search_posts: "Wyszukaj posty w kanale...",
    delete_comment: "Usuń",
    no_comments: "Brak komentarzy. Bądź pierwszy!",
    comments_disabled: "Komentarze są wyłączone dla tego kanału.",
    comment_placeholder: "Napisz komentarz...",
    send: "Wyślij",
    plan_post: "Zaplanuj",
    reset: "Resetuj",
    publish: "Opublikuj",
    publishing: "Publikowanie...",
    plan_label: "📅 Zaplanuj:",
    attached_image: "Dołączono obraz (zaszyfrowany)"
  },
  uk: {
    discover: "🔎 Знайти",
    create_tab: "➕ Створити канал",
    create_header: "Створити канал",
    edit_header: "Редагувати канал",
    channel_name: "Назва каналу (Handle)",
    category: "Категорія",
    description: "Опис",
    set_image: "Встановити зашифроване зображення",
    saving: "Збереження...",
    save_channel: "Зберегти канал",
    cancel: "Скасувати",
    create_identity_msg: "Спочатку створіть ідентичність, щоб переглядати, підписуватися та публікувати канали.",
    channels_backend_unavailable: "Маршрут бекенду каналів недоступний",
    channels_backend_unavailable_desc: "Для розгорнутого бекенду потрібні нові маршрути публічних каналів, перш ніж канали можна буде використовувати на цьому сервері.",
    no_channels: "Не знайдено невідкритих каналів.",
    searching: "Пошук каналів...",
    no_description: "Немає опису.",
    subscribers: "підписників",
    owner: "Власник",
    federated_trust: "Федеративна довіра",
    search_placeholder: "Пошук каналів...",
    search_btn: "Пошук",
    subscribe: "Підписатися",
    unsubscribe: "Скасувати підписку",
    block: "Заблокувати",
    block_action: "Заблокувати канал",
    report_action: "Поскаржитися на канал",
    channel_menu: "Меню каналу",
    edit_btn: "Редагувати",
    comments_on: "Коментарі увімкн.",
    comments_off: "Коментарі вимкн.",
    delete_channel: "Видалити канал",
    decertify: "Скасувати сертифікацію",
    certify: "Сертифікувати канал",
    public_channel: "Публічний канал",
    admin_console: "Консоль адміністратора",
    viewer_mode: "Режим глядача",
    verified_by: "✓ Перевірено",
    create_channel_empty_desc: "Створіть новий канал для публікації криптографічно підписаних оголошень.",
    create_channel_empty_btn: "Створити зараз",
    report_title: "Поскаржитися на канал",
    report_category: "Категорія порушення",
    report_severity: "Рівень терміновості",
    report_notes: "Додаткові примітки або докази",
    report_placeholder: "Надайте деталі або криптографічне підтвердження порушення...",
    report_submit: "Надіслати скаргу",
    report_submitting: "Надсилання...",
    search_posts: "Пошук публікацій у каналі...",
    delete_comment: "Видалити",
    no_comments: "Коментарів ще немає. Будьте першими!",
    comments_disabled: "Коментарі для цього каналу вимкнено.",
    comment_placeholder: "Напишіть коментар...",
    send: "Надіслати",
    plan_post: "Запланувати",
    reset: "Скинути",
    publish: "Опублікувати",
    publishing: "Публікація...",
    plan_label: "📅 Запланувати:",
    attached_image: "Зображення додано (зашифровано)"
  },
  ko: {
    discover: "🔎 발견",
    create_tab: "➕ 채널 만들기",
    create_header: "채널 만들기",
    edit_header: "채널 편집",
    channel_name: "채널명 (Handle)",
    category: "카테고리",
    description: "설명",
    set_image: "암호화 이미지 설정",
    saving: "저장 중...",
    save_channel: "채널 저장",
    cancel: "취소",
    create_identity_msg: "채널을 조회, 구독 및 개설하려면 먼저 아이덴티티를 만드십시오.",
    channels_backend_unavailable: "채널 백엔드 경로를 사용할 수 없음",
    channels_backend_unavailable_desc: "이 서버에서 채널을 사용하려면 배포된 백엔드에 새로운 퍼블릭 채널 경로가 활성화되어야 합니다.",
    no_channels: "발견되지 않은 채널이 없습니다.",
    searching: "채널 검색 중...",
    no_description: "설명이 없습니다.",
    subscribers: "명의 구독자",
    owner: "소유자",
    federated_trust: "연합 신뢰",
    search_placeholder: "채널 검색...",
    search_btn: "검색",
    subscribe: "구독하기",
    unsubscribe: "구독 취소",
    block: "차단",
    block_action: "채널 차단",
    report_action: "채널 신고",
    channel_menu: "채널 메뉴",
    edit_btn: "편집",
    comments_on: "댓글 켜짐",
    comments_off: "댓글 꺼짐",
    delete_channel: "채널 삭제",
    decertify: "인증 취소",
    certify: "채널 인증",
    public_channel: "퍼블릭 채널",
    admin_console: "관리자 콘솔",
    viewer_mode: "뷰어 모드",
    verified_by: "✓ 인증 제공자",
    create_channel_empty_desc: "암호화 서명된 공지사항을 게시할 새 채널을 만듭니다.",
    create_channel_empty_btn: "지금 만들기",
    report_title: "채널 신고",
    report_category: "위반 카테고리",
    report_severity: "긴급도",
    report_notes: "추가 메모 또는 증거",
    report_placeholder: "위반 사항의 세부 정보 또는 암호화 증명을 제공하십시오...",
    report_submit: "신고 제출",
    report_submitting: "신고 중...",
    search_posts: "채널 내 포스트 검색...",
    delete_comment: "삭제",
    no_comments: "아직 댓글이 없습니다. 첫 댓글을 남겨보세요!",
    comments_disabled: "이 채널의 댓글 기능이 비활성화되었습니다.",
    comment_placeholder: "댓글 작성...",
    send: "전송",
    plan_post: "예약",
    reset: "초기화",
    publish: "게시",
    publishing: "게시 중...",
    plan_label: "📅 예약 발송:",
    attached_image: "이미지 첨부됨 (암호화)"
  },
  id: {
    discover: "🔎 Temukan",
    create_tab: "➕ Buat Saluran",
    create_header: "Buat Saluran",
    edit_header: "Edit Saluran",
    channel_name: "Nama saluran (Handle)",
    category: "Kategori",
    description: "Deskripsi",
    set_image: "Setel gambar terenkripsi",
    saving: "Menyimpan...",
    save_channel: "Simpan Saluran",
    cancel: "Batal",
    create_identity_msg: "Buat identitas terlebih dahulu untuk melihat, berlangganan, dan menerbitkan saluran.",
    channels_backend_unavailable: "Rute backend saluran tidak tersedia",
    channels_backend_unavailable_desc: "Backend yang dipasang memerlukan rute saluran publik baru sebelum saluran dapat digunakan di server ini.",
    no_channels: "Tidak ada saluran baru yang ditemukan.",
    searching: "Mencari saluran...",
    no_description: "Tidak ada deskripsi.",
    subscribers: "pelanggan",
    owner: "Pemilik",
    federated_trust: "Kepercayaan Terdistribusi",
    search_placeholder: "Cari saluran...",
    search_btn: "Cari",
    subscribe: "Langganan",
    unsubscribe: "Batal Langganan",
    block: "Blokir",
    block_action: "Blokir saluran",
    report_action: "Laporkan saluran",
    channel_menu: "Menu Saluran",
    edit_btn: "Edit",
    comments_on: "Komentar Aktif",
    comments_off: "Komentar Nonaktif",
    delete_channel: "Hapus Saluran",
    decertify: "Batalkan Sertifikasi",
    certify: "Sertifikasi Saluran",
    public_channel: "Saluran Publik",
    admin_console: "Konsol Admin",
    viewer_mode: "Mode Pemirsa",
    verified_by: "✓ Diverifikasi oleh",
    create_channel_empty_desc: "Buat saluran baru untuk menerbitkan pengumuman yang ditandatangani secara kriptografis.",
    create_channel_empty_btn: "Buat Sekarang",
    report_title: "Laporkan saluran",
    report_category: "Kategori pelanggaran",
    report_severity: "Tingkat urgensi / keparahan",
    report_notes: "Catatan tambahan atau bukti",
    report_placeholder: "Berikan detail atau bukti kriptografi pelanggaran...",
    report_submit: "Kirim laporan",
    report_submitting: "Melaporkan...",
    search_posts: "Cari postingan di saluran...",
    delete_comment: "Hapus",
    no_comments: "Belum ada komentar. Jadilah yang pertama!",
    comments_disabled: "Komentar dinonaktifkan untuk saluran ini.",
    comment_placeholder: "Tulis komentar...",
    send: "Kirim",
    plan_post: "Jadwalkan",
    reset: "Reset",
    publish: "Terbitkan",
    publishing: "Menerbitkan...",
    plan_label: "📅 Jadwalkan:",
    attached_image: "Gambar dilampirkan (terenkripsi)"
  },
  sq: {
    discover: "🔎 Zbulo",
    create_tab: "➕ Krijo Kanal",
    create_header: "Krijo Kanal",
    edit_header: "Ndrysho Kanalin",
    channel_name: "Emri i kanalit (Handle)",
    category: "Kategoria",
    description: "Përshkrimi",
    set_image: "Vendos imazh të koduar",
    saving: "Duke u ruajtur...",
    save_channel: "Ruaj Kanalin",
    cancel: "Anulo",
    create_identity_msg: "Krijoni një identitet fillimisht për të parë, abonuar dhe publikuar kanale.",
    channels_backend_unavailable: "Rruga e backend-it të kanaleve nuk është e disponueshme",
    channels_backend_unavailable_desc: "Backend-i i vendosur ka nevojë për rrugët e reja të kanaleve publike përpara se kanalet të mund të përdoren në këtë server.",
    no_channels: "Nuk u gjet asnjë kanal i pazbuluar.",
    searching: "Duke kërkuar kanale...",
    no_description: "Nuk ka përshkrim.",
    subscribers: "abonentë",
    owner: "Pronari",
    federated_trust: "Besimi i Federuar",
    search_placeholder: "Kërko kanale...",
    search_btn: "Kërko",
    subscribe: "Abonohu",
    unsubscribe: "Çabonohu",
    block: "Blloko",
    block_action: "Blloko kanalin",
    report_action: "Raporto kanalin",
    channel_menu: "Menuja e Kanalit",
    edit_btn: "Ndrysho",
    comments_on: "Komentet Aktiv",
    comments_off: "Komentet Joaktiv",
    delete_channel: "Fshi Kanalin",
    decertify: "Çertifiko",
    certify: "Çertifiko Kanalin",
    public_channel: "Kanal Publik",
    admin_console: "Konsola e Adminit",
    viewer_mode: "Mënyra e Shikuesit",
    verified_by: "✓ Verifikuar nga",
    create_channel_empty_desc: "Krijo një kanal të ri për të publikuar njoftime të nënshkruara në mënyrë kriptografike.",
    create_channel_empty_btn: "Krijo Tani",
    report_title: "Raporto kanalin",
    report_category: "Kategoria e shkeljes",
    report_severity: "Niveli i urgjencës",
    report_notes: "Shënime shtesë ose prova",
    report_placeholder: "Jepni detaje ose prova kriptografike të shkeljes...",
    report_submit: "Dërgo raportin",
    report_submitting: "Duke raportuar...",
    search_posts: "Kërko postime në kanal...",
    delete_comment: "Fshi",
    no_comments: "Nuk ka ende komente. Bëhu i pari!",
    comments_disabled: "Komentet janë çaktivizuar për këtë kanal.",
    comment_placeholder: "Shkruaj një koment...",
    send: "Dërgo",
    plan_post: "Planifiko",
    reset: "Rivendos",
    publish: "Publiko",
    publishing: "Duke publikuar...",
    plan_label: "📅 Planifiko:",
    attached_image: "Imazhi i bashkëngjitur (i koduar)"
  }
};

const commonChannelTranslationComplements = {
  action_failed: "Action failed.",
  category_all: "All",
  category_entertainment: "Entertainment",
  category_general: "General",
  category_news: "News",
  category_sports: "Sports",
  category_tech: "Tech",
  channel_control: "Channel Control",
  channel_status_updated: "Channel status was updated.",
  channel_suspended_desc: "This channel was suspended by abuse consensus for policy violations. Reason",
  channel_suspended_title: "Channel Suspended",
  certified: "Certified",
  anonymous: "Anonymous",
  close: "Close",
  confirm_delete_desc: "Do you really want to permanently delete this channel? This cannot be undone and all posts will be deleted.",
  confirm_delete_title: "Delete channel",
  decertified: "Certification removed",
  default_owner: "Lead Moderator",
  delete_failed: "Delete failed.",
  format_bold: "Bold",
  format_italic: "Italic",
  format_underline: "Underline",
  menu: "Menu",
  overview: "Overview",
  policy_violation: "Policy violation",
  post_placeholder: "Share an encrypted update...",
  report_failed: "Report failed.",
  report_harassment: "Harassment / Threat",
  report_illegal_content: "Illegal content",
  report_malware: "Malware / Technical attacks",
  report_other: "Other",
  report_phishing: "Fraud / Phishing",
  report_sent_desc: "The channel has been reported to the moderators.",
  report_sent_title: "Report sent",
  report_spam: "Spam / Abuse",
  report_threat: "Immediate threat / danger",
  save_failed: "Channel could not be saved.",
  severity_critical: "Critical",
  severity_high: "High",
  severity_low: "Low",
  severity_medium: "Medium"
};

const channelTranslationComplements = {
  de: {
    action_failed: "Aktion fehlgeschlagen.",
    category_all: "Alle",
    category_entertainment: "Unterhaltung",
    category_general: "Allgemein",
    category_news: "Nachrichten",
    category_sports: "Sport",
    category_tech: "Technik",
    channel_control: "Kanalsteuerung",
    channel_status_updated: "Kanalstatus wurde aktualisiert.",
    channel_suspended_desc: "Dieser Kanal wurde durch den Abuse-Consensus wegen Richtlinienverstößen gesperrt. Begründung",
    channel_suspended_title: "Kanal gesperrt",
    certified: "Zertifiziert",
    anonymous: "Anonym",
    close: "Schließen",
    confirm_delete_desc: "Möchtest du diesen Kanal wirklich dauerhaft löschen? Dies kann nicht rückgängig gemacht werden und alle Beiträge werden gelöscht.",
    confirm_delete_title: "Kanal löschen",
    decertified: "Zertifizierung entzogen",
    default_owner: "Haupt-Moderator",
    delete_failed: "Löschen fehlgeschlagen.",
    format_bold: "Fett",
    format_italic: "Kursiv",
    format_underline: "Unterstrichen",
    menu: "Menü",
    policy_violation: "Richtlinienverletzung",
    post_placeholder: "Teile ein verschlüsseltes Update...",
    report_failed: "Meldung fehlgeschlagen.",
    report_harassment: "Belästigung / Bedrohung",
    report_illegal_content: "Illegale Inhalte",
    report_malware: "Malware / technische Angriffe",
    report_other: "Sonstiges",
    report_phishing: "Betrug / Phishing",
    report_sent_desc: "Der Kanal wurde den Moderatoren gemeldet.",
    report_sent_title: "Report gesendet",
    report_spam: "Spam / Abuse",
    report_threat: "Akute Bedrohung / Gefahr",
    save_failed: "Kanal konnte nicht gespeichert werden.",
    severity_critical: "Kritisch",
    severity_high: "Hoch",
    severity_low: "Niedrig",
    severity_medium: "Mittel",
    no_posts: "Keine Beiträge gefunden.",
    pinned: "Fixiert",
    pin: "Fixieren",
    unpin: "Lösen",
    comments: "Kommentare"
  },
  en: { no_posts: "No posts found.", pinned: "Pinned", pin: "Pin", unpin: "Unpin", comments: "Comments" },
  ru: { no_posts: "Публикации не найдены.", pinned: "Закреплено", pin: "Закрепить", unpin: "Открепить", comments: "Комментарии" },
  es: { no_posts: "No se encontraron publicaciones.", pinned: "Fijado", pin: "Fijar", unpin: "Desfijar", comments: "Comentarios" },
  fr: { no_posts: "Aucune publication trouvée.", pinned: "Épinglé", pin: "Épingler", unpin: "Désépingler", comments: "Commentaires" },
  fa: { no_posts: "هیچ پستی پیدا نشد.", pinned: "سنجاق‌شده", pin: "سنجاق کردن", unpin: "برداشتن سنجاق", comments: "دیدگاه‌ها" },
  ja: { no_posts: "投稿が見つかりません。", pinned: "固定済み", pin: "固定", unpin: "固定解除", comments: "コメント" },
  pt: { no_posts: "Nenhuma publicação encontrada.", pinned: "Fixado", pin: "Fixar", unpin: "Desafixar", comments: "Comentários" },
  ar: { no_posts: "لم يتم العثور على منشورات.", pinned: "مثبت", pin: "تثبيت", unpin: "إلغاء التثبيت", comments: "التعليقات" },
  zh: { no_posts: "未找到帖子。", pinned: "已置顶", pin: "置顶", unpin: "取消置顶", comments: "评论" },
  hi: { no_posts: "कोई पोस्ट नहीं मिली।", pinned: "पिन किया गया", pin: "पिन करें", unpin: "अनपिन करें", comments: "टिप्पणियाँ" },
  tr: { no_posts: "Gönderi bulunamadı.", pinned: "Sabitlendi", pin: "Sabitle", unpin: "Sabitlemeyi kaldır", comments: "Yorumlar" },
  it: { no_posts: "Nessun post trovato.", pinned: "Fissato", pin: "Fissa", unpin: "Rimuovi fissaggio", comments: "Commenti" },
  pl: { no_posts: "Nie znaleziono postów.", pinned: "Przypięte", pin: "Przypnij", unpin: "Odepnij", comments: "Komentarze" },
  uk: { no_posts: "Публікацій не знайдено.", pinned: "Закріплено", pin: "Закріпити", unpin: "Відкріпити", comments: "Коментарі" },
  ko: { no_posts: "게시물을 찾을 수 없습니다.", pinned: "고정됨", pin: "고정", unpin: "고정 해제", comments: "댓글" },
  id: { no_posts: "Tidak ada postingan ditemukan.", pinned: "Disematkan", pin: "Sematkan", unpin: "Lepas sematan", comments: "Komentar" },
  sq: { no_posts: "Nuk u gjet asnjë postim.", pinned: "I fiksuar", pin: "Fikso", unpin: "Hiq fiksimin", comments: "Komentet" }
};

Object.entries(channelTranslationComplements).forEach(([language, entries]) => {
  channelTranslations[language] = {
    ...commonChannelTranslationComplements,
    ...(channelTranslations[language] || {}),
    ...entries
  };
});
